import type { DashboardUserProfile } from '@services/firebase'
import type { FlashcardCard as FlashcardCardModel } from '@services/firebase/flashcards'
import { resolvePreferredAudioSource } from '@shared/media/audio/audio-source'
import { resolveFlashcardTranslation } from '@features/flashcards/shared/flashcard-language'
import { FlashcardCard } from './FlashcardCard'
import './flashcard-collection.css'

export function FlashcardCardGrid({
  cards,
  locale,
  onPreview,
  onToggleSelected,
  profile,
  selectedCardIds,
}: {
  readonly cards: FlashcardCardModel[]
  readonly locale: string
  readonly onPreview: (cardId: string) => void
  readonly onToggleSelected: (cardId: string) => void
  readonly profile: DashboardUserProfile | null
  readonly selectedCardIds: string[]
}) {
  return (
    <div className="flashcardCollectionGrid">
      {cards.map((card) => (
        <FlashcardCard
          audio={resolvePreferredAudioSource({ card, profile })}
          card={card}
          isSelected={selectedCardIds.includes(card.id)}
          key={card.id}
          onPreview={() => {
            onPreview(card.id)
          }}
          onToggleSelected={() => {
            onToggleSelected(card.id)
          }}
          translation={resolveFlashcardTranslation(card, locale)}
        />
      ))}
    </div>
  )
}
